import { Controller } from "@hotwired/stimulus"

// 테이블 체크박스 전체 선택/해제 컨트롤러
export default class extends Controller {
  static targets = ["selectAll", "item", "count", "action", "createBtn", "downloadBtn", "cancelForm", "deleteForm"]

  connect() {
    this.updateState()
  }

  // 전체 선택/해제 토글
  toggleAll(event) {
    const checked = event.target.checked
    this.itemTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateState()
  }

  // 개별 항목 변경 시
  toggleItem() {
    this.updateState()
  }

  // 상태 업데이트 (선택 개수, 전체 선택 체크박스 상태, 버튼 활성화)
  updateState() {
    const total = this.itemTargets.length
    const checked = this.itemTargets.filter(cb => cb.checked).length

    // 선택 개수 업데이트
    if (this.hasCountTarget) {
      this.countTarget.textContent = checked
    }

    // 전체 선택 체크박스 상태 업데이트
    if (this.hasSelectAllTarget) {
      if (total === 0) {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = false
      } else if (checked === 0) {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = false
      } else if (checked === total) {
        this.selectAllTarget.checked = true
        this.selectAllTarget.indeterminate = false
      } else {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = true
      }
    }

    // 액션 버튼 활성화/비활성화
    this.actionTargets.forEach(button => {
      button.disabled = checked === 0
    })

    // 생성 버튼: 선택된 항목이 모두 미생성(has_label=false)일 때만 활성화
    if (this.hasCreateBtnTarget) {
      const checkedItems = this.itemTargets.filter(cb => cb.checked)
      const allWithoutLabel = checkedItems.length > 0 &&
        checkedItems.every(cb => cb.dataset.hasLabel === 'false')
      this.createBtnTarget.disabled = !allWithoutLabel
    }

    // 다운로드 버튼: 선택된 항목이 있으면 활성화
    if (this.hasDownloadBtnTarget) {
      this.downloadBtnTarget.disabled = checked === 0
    }
  }

  // 선택된 항목 ID 배열 반환
  getSelectedIds() {
    return this.itemTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }

  // 취소 확인 모달 열기
  openCancelModal(event) {
    event.preventDefault()
    if (this.getSelectedIds().length === 0) return

    this.openModal('batch-cancel-modal')
  }

  // 삭제 확인 모달 열기
  openDeleteModal(event) {
    event.preventDefault()
    if (this.getSelectedIds().length === 0) return

    this.openModal('batch-delete-modal')
  }

  // 모달 열기 헬퍼
  openModal(modalId) {
    const modalElement = document.getElementById(modalId)
    if (modalElement) {
      const modalController = this.application.getControllerForElementAndIdentifier(modalElement, 'modal')
      if (modalController) {
        modalController.open()
      }
    }
  }

  // 취소 확인 시 폼 제출
  confirmCancel(event) {
    this.submitFormWithSelectedIds(this.cancelFormTarget)
  }

  // 삭제 확인 시 폼 제출
  confirmDelete(event) {
    this.submitFormWithSelectedIds(this.deleteFormTarget)
  }

  // 선택된 ID를 폼에 추가하고 제출
  submitFormWithSelectedIds(form) {
    if (!form) return

    const selectedIds = this.getSelectedIds()
    if (selectedIds.length === 0) return

    // 기존 hidden input 제거
    form.querySelectorAll('input[name="selected_ids[]"]').forEach(el => el.remove())

    // 선택된 ID들을 hidden input으로 추가
    selectedIds.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'selected_ids[]'
      input.value = id
      form.appendChild(input)
    })

    // 폼 제출
    form.requestSubmit()
  }
}
